import styled from 'styled-components';

export const SearchContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  & .search-field {
    width: 100%;
    margin: 0.7%;
    & .hefesto-dropdown .hefesto-dropdown--top {
      border: solid;
      width: 48rem;
    }
  }
  & .button-container {
    width: 50%;
    margin-left: 50%;
    & .hefesto-button {
      margin-top: 1.5rem;
    }
  }
`;
